import { render, staticRenderFns } from "./TrabajosTable.vue?vue&type=template&id=07d54365&scoped=true&"
import script from "./TrabajosTable.vue?vue&type=script&lang=js&"
export * from "./TrabajosTable.vue?vue&type=script&lang=js&"
import style0 from "./TrabajosTable.vue?vue&type=style&index=0&id=07d54365&lang=scss&scoped=true&"
import style1 from "./TrabajosTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d54365",
  null
  
)

export default component.exports